import React, { SVGProps } from "react";

export const JiraServiceManagementMarkBrandV2 = ({
  width = "100%",
  height = "100%",
}: Pick<SVGProps<SVGSVGElement>, "height" | "width">) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="6.144 3.84 35.135999999999996 40.032"
    width={width}
    height={height}
  >
    <g id="Container">
      <path
        fill="#101214"
        d="M28.1863 19.5744H39.1729C40.8229 19.5744 41.3863 21.1439 40.3802 22.3915L23.196 43.6C17.6424 39.1732 18.1655 32.1707 22.2302 27.0598L28.1863 19.5744ZM19.6948 28.0256H8.70823C7.05823 28.0256 6.49481 26.4561 7.50091 25.2085L24.6851 4C30.2387 8.42683 29.6351 15.3488 25.6107 20.5L19.6948 28.0256Z"
      />
    </g>
  </svg>
);

export default JiraServiceManagementMarkBrandV2;
